import client from './client';

export function getSelfReflectionConfig() {
  return client.get('/api/self-reflection/config');
}

export function getMySelfReflection() {
  return client.get('/api/self-reflection/me');
}

export function saveMySelfReflection(payload) {
  return client.put('/api/self-reflection/me', payload);
}

export function deleteMySelfReflection(confirmation) {
  return client.delete('/api/self-reflection/me', { data: { confirmation } });
}

export function listSelfReflectionSubjects() {
  return client.get('/api/self-reflection/subjects');
}

export function listSelfReflectionAnalysisCandidates() {
  return client.get('/api/self-reflection/analysis-candidates');
}

export function getSelfReflectionSubject(subjectId) {
  return client.get(`/api/self-reflection/subjects/${subjectId}`);
}

export function getSelfReflectionAssessmentProgress(subjectId) {
  return client.get(`/api/self-reflection/subjects/${subjectId}/assessment-progress`);
}

export function setSelfReflectionSubjectExcluded(subjectId, excluded) {
  return client.request({
    method: excluded ? 'put' : 'delete',
    url: `/api/self-reflection/subjects/${subjectId}/exclusion`,
  });
}

export function saveInstructorSelfReflection(subjectId, payload) {
  return client.put(`/api/self-reflection/subjects/${subjectId}/instructor-assessment`, payload);
}

export function analyzeSelfReflections(userIds, mode = 'combined') {
  return client.post('/api/self-reflection/analysis', { userIds, mode });
}